import { BRAND } from "@/lib/brand";
import { usePump } from "@/context/PumpContext";

const DEFAULT_CC = "265138";

export function usePumpBrand() {
  const { pump } = usePump();
  const isBep = !pump || pump.cc === DEFAULT_CC;
  return {
    name: pump?.name || BRAND.name,
    sub: pump ? `Dam Duty · ${pump.oil_company_name?.match(/\((.*)\)/)?.[1] || pump.oil_company_name}` : "Dam Duty · BPCL",
    logo: isBep ? BRAND.logo : null,
    color: pump?.theme?.primary || "#007BC9",
    initial: (pump?.name || BRAND.name)[0],
  };
}

export function LogoBox({ className = "w-11 h-11" }) {
  const b = usePumpBrand();
  if (b.logo) return <img src={b.logo} alt={b.name} className={`${className} rounded-xl object-contain bg-white ring-1 ring-slate-200 p-1 shadow-sm`} />;
  return <span className={`${className} rounded-xl grid place-items-center text-white font-display font-bold text-lg shadow-sm`} style={{ background: b.color }}>{b.initial}</span>;
}

/** Small wordmark row — used in headers. */
export function BrandMark({ compact = false, tone = "default" }) {
  const b = usePumpBrand();
  return (
    <div className="flex items-center gap-3">
      <LogoBox className={compact ? "w-9 h-9" : "w-11 h-11"} />
      {!compact && (
        <div className="leading-tight">
          <div className={`font-display font-bold ${tone === "light" ? "text-white" : "text-slate-900"}`} data-testid="brand-name">
            {b.name}
          </div>
          <div className={`text-[11px] ${tone === "light" ? "text-white/80" : "text-slate-500"} -mt-0.5`}>
            {b.sub}
          </div>
        </div>
      )}
    </div>
  );
}

/** Big logo for hero surfaces. */
export function BigLogo({ className = "" }) {
  return <LogoBox className={className} />;
}

export default BrandMark;
